import { combineReducers } from "redux"
import flightsReducer from "./flights/slice"
import firesReducer from "./fires/slice"
import { reducer as InfraredImageUpload } from "plugins/InfraredImage/InfraredImageSlice"
import { reducer as OrthoImageUpload } from "plugins/Orthomosaic/OrthomosaicSlice"
import { reducer as VideoUpload } from "plugins/Video/FMV/VideoSlice"
import { reducer as ColorFinder } from "plugins/ColorFinder/VideoColorFinder/ColorFinderSlice"
import { reducer as ImageColorFinder } from "plugins/ColorFinder/ImageColorFinder/ImageColorFinderSlice"
import { reducer as Panorama } from "plugins/Panorama/PanoramaSlice"
import { reducer as Icon } from "plugins/Toolbox/Icons/IconSlice"

export const entitiesReducers = combineReducers({
    flights: flightsReducer,
    fires: firesReducer,
    ...InfraredImageUpload,
    ...OrthoImageUpload,
    ...VideoUpload,
    ...ColorFinder,
    ...ImageColorFinder,
    ...Panorama,
    ...Icon,
})

export default entitiesReducers
